import { trackYandexGoal } from '@actions/utils';
import UiButton from '@ui/Button';
import { getTimeZone } from '@utils/date';
import React, { useState } from 'react';
import { I18n } from 'react-redux-i18n';
import request from 'superagent';

const CryptoButton = props => {
  const { plan, phone, isValid, email, onClickPay } = props;
  const [loading, setLoading] = useState(false);

  const processPayment = () => {
    onClickPay();

    if (loading || !isValid) return;

    trackYandexGoal(`buy-${plan}`);

    setLoading(true);

    request
      .post('/payment/init')
      .send({
        tel: phone,
        plan,
        email,
        method: 'crypto',
        timezone: getTimeZone(),
      })
      .end((err, res) => {
        setLoading(false);
        if (!err && res.body.url) window.location = res.body.url;
      });
  };

  return (
    <UiButton
      onClick={processPayment}
      color="green"
      size="big"
      style={{ maxWidth: 300 }}
      test-id="paymentOption-button-crypto"
      disabled={loading}
    >
      <img
        src={require('../../../../../assets/images/icon-btc.svg')}
        alt="btc"
      />{' '}
      <img
        src={require('../../../../../assets/images/icon-dogecoin.svg')}
        alt="dogecoin"
      />{' '}
      {loading ? '...' : I18n.t('other.payByCrypto')}
    </UiButton>
  );
};

export default CryptoButton;
